import formatDate from './format-date';
import resizeImage from './resize-image';
import capitalize from './capitalize';
import formatTag from './formatTag';
import uppercase from './uppercase';
import lowercase from './lowercase';
import phone from './phone';
import limitReplacers from './limit-replacers';
import reverse from './reverse';
import diffForHumans from './diff-for-humans';
import iconFilter from './icon-filter';
import formatMoney from './formatMoney';
import numberConversion from './number-conversion';
import rtlTextDirection from './rtl-text-direction';

export default {
  install(Vue) {
    Vue.filter('formatDate', formatDate);
    Vue.filter('resizeImage', resizeImage);
    Vue.filter('capitalize', capitalize);
    Vue.filter('uppercase', uppercase);
    Vue.filter('lowercase', lowercase);
    Vue.filter('phone', phone);
    Vue.filter('limitReplacers', limitReplacers);
    Vue.filter('reverse', reverse);
    Vue.filter('diffForHumans', diffForHumans);
    Vue.filter('iconFilter', iconFilter);
    Vue.filter('formatMoney', formatMoney);
    Vue.filter('numberConversion', numberConversion);
    Vue.filter('rtlTextClass', rtlTextDirection);
    Vue.filter('formatTag', formatTag);
  },
};



// WEBPACK FOOTER //
// ./src/filter/index.js